export default "@property --gradient-deg{syntax:\"<angle>\";initial-value:0deg;inherits:false}";